module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":null,"en":null}')
  delete Component.options._Ctor
}
